import React, { Component } from 'react';
import {
  BreadcrumbContainer,
  BreadcrumbButton,
  EmbedButton,
  Text,
} from 'prospect-path-components';
import { TooltipButton } from 'prospect-path-base';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Heading from '../../components/product-management/heading';

import BreadcrumbWrapper from '../../components/product-management/layout/breadcrumb-wrapper';
import HeadingContainer from '../../components/product-management/layout/heading-container';

import getAwardsForProduct from '../../actions/product-management/GetAwardsForProduct';
import { history } from '../../store';
import NotFound from '../not-found';

const Placeholder = styled.div`
  background: #f9f9f9;
  border-radius: 8px;
  padding: 10px;
  width: 216px;
  min-height: 167px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Col = styled.div`
  flex: 1;
  margin-right: 1rem;
`;

const Row = styled.div`
  display: flex;
  max-width: 60rem;

  @media screen and (max-width: 768px) {
    flex-wrap: wrap;

    ${Col} {
      margin-bottom: 1rem;
      flex-wrap: wrap;
      flex: 0 50%;
    }
  }
`;

const AwardContainer = styled.div`
  margin-bottom: 4rem;
`;

const AwardHeadingContainer = styled.div`
  display: flex;
  margin-bottom: 2rem;
`;

const AwardIcon = styled.img`
`;

const AwardActions = styled.div`
  margin-top: 1rem;
  display: flex;
  align-items: center;
`;

const AwardHeading = styled.h3`
  font-family: "Cerebri Sans", sans-serif;
  padding: 0;
  margin: 0;
  margin-top: auto;
  margin-bottom: auto;
`;

class Awards extends Component {
  constructor(props) {
    super(props);

    this.state = {
      copiedToClipboard: null,
    };

    this.awardsAreLoaded = this.awardsAreLoaded.bind(this);
    this.getProduct = this.getProduct.bind(this);
  }
  componentWillMount() {
    this.props.getAwardsForProduct(
      parseInt(this.props.currentTeamId),
      parseInt(this.props.match.params.product_id),
    );
  }
  getProduct() {
    const team = this.props.teams
      .find(team => team.id === parseInt(this.props.currentTeamId));

    if (team === undefined) {
      return undefined;
    }

    const product = team.products.find(
      product => product.id === parseInt(this.props.match.params.product_id)
    );

    if (product !== undefined) {
      document.title = `${product.name} Awards | Prospect Path`;
    }

    return product;
  }
  awardsAreLoaded() {
    return parseInt(this.props.match.params.product_id) === this.props.awards.productId;
  }
  copyEmbedCode(award) {
    const el = document.createElement('textarea');
    el.value = `<!-- Prospect Path Award id: ${award.id} --><a href="${award.link}"><img src="${award.image}" alt="${award.text} on Software Path" style="width:${award.award_type_reference === 'software_path_ranking' ? '112px' : 'auto'}" /></a>`;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);

    this.setState({ copiedToClipboard: award.id });
  }
  render() {
    if (!this.props.awardsEnabled) {
      return <NotFound />;
    }

    if (this.props.user.id === null) {
      window.location = '/login?redirect=/products';
    }

    let awards = '';
    if (this.awardsAreLoaded()) {
      awards = this.props.awards.awards.map(award => (
        <Col key={award.id}>
          <Placeholder>
            <a
              href={award.link}
              target="_blank"
            >
              <span style={{ display: 'inline-block' }}>
                <img
                  style={{ width: award.award_type_reference === 'software_path_ranking' ? '112px' : 'auto' }} // Ranking awards are displayed at 50%
                  src={award.image}
                  alt={award.text}
                />
              </span>
            </a>
          </Placeholder>
          <AwardActions>
            <EmbedButton onClick={() => this.copyEmbedCode(award)}>
              { this.state.copiedToClipboard === award.id ? 'Copied to Clipboard!' : 'Embed' }
            </EmbedButton>
            <TooltipButton
              style={{ background: 'white', margin: '0.25rem 0' }}
              icon={() => (
                <svg width="16" height="16" viewBox="0 0 16 16">
                  <defs />
                  <path d="M8 0a8 8 0 110 16A8 8 0 018 0zm0 2a6 6 0 100 12A6 6 0 008 2zm0 5a1 1 0 011 1v3a1 1 0 01-2 0V8a1 1 0 011-1zm0-3a1 1 0 110 2 1 1 0 010-2z" fill="#BBB" fillRule="evenodd" />
                </svg>
              )}
              tooltipProps={{
                content: () => (
                  <p>
                    Click the Embed button to copy an embed code to your clipboard. Add this code to your website to display your award. Email <a style={{ color: 'white' }} href="mailto:info@prospectpath.com">info@prospectpath.com</a> for more formats and resolutions.
                  </p>
                ),
              }}
            />
          </AwardActions>
        </Col>
      ));
    }

    return (
      <div>
        <div className="l-wrapper-content">
          <section className="l-wrapper-container">

            <header className="l-billing-header">
              <div style={{ maxWidth: '60rem' }}>
                <HeadingContainer>
                  <Heading>{this.getProduct() ? this.getProduct().name : ''}</Heading>

                  <BreadcrumbWrapper>
                    <BreadcrumbContainer>
                      <BreadcrumbButton
                        onClick={() => history.push(`/products/${this.props.match.params.product_id}`)}
                      >
                        Overview
                      </BreadcrumbButton>
                      <BreadcrumbButton
                        onClick={() => history.push(`/products/${this.props.match.params.product_id}/promote`)}
                      >
                        Promote
                      </BreadcrumbButton>
                      <BreadcrumbButton active>Awards</BreadcrumbButton>
                    </BreadcrumbContainer>
                  </BreadcrumbWrapper>
                </HeadingContainer>
              </div>
            </header>

            <AwardContainer>
              <AwardHeadingContainer>
                <AwardIcon
                  width={36}
                  height={36}
                  src="/images/awards/software-path-logo.svg"
                  alt="Software Path Logo"
                />
                <AwardHeading
                  style={{ marginLeft: '5px' }}
                >Software Path</AwardHeading>
              </AwardHeadingContainer>

              <Row>
                {awards}
              </Row>
            </AwardContainer>
          </section>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  awards: state.productManagement.awards,
  teams: state.teams.all,
  currentTeamId: state.teams.currentTeam,
  awardsEnabled: state.featureFlags.ProductManagementAwards,
});
const mapDispatchToProps = dispatch => ({
  getAwardsForProduct:
    (teamId, productId) => dispatch(getAwardsForProduct(teamId, productId)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Awards));
